const tr = {
    en: {
        legalPrompt1: "Once you proceed, you will be deemed to have read and agreed to be bound by the Now E",
        legalPrompt2: " Terms and Conditions",
        legalPrompt3: " and ",
        legalPrompt4: " Things to Know.",
        legalPrompt5: "",
    },
    zh: {
        legalPrompt1: "如繼續，您將被視為已閱讀並同意受Now E",
        legalPrompt2: " 條款及條件",
        legalPrompt3: " 及 ",
        legalPrompt4: " 用戶須知",
        legalPrompt5: "的约束。",
    }
}

export default tr;
